/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Grid from '../../../../../../lib/clear-bi/grid/components/Grid';

const useStyles = makeStyles(() => ({
  grid: {
    height: '55%',
  },
}));

const TeamAlertsGrid = ({
  keyGrid,
  columns,
  data,
  actions,
  options,
  localization,
  isLoading,
  components
}) => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.grid}
      keyGrid={keyGrid}
      columns={columns}
      data={data}
      actions={actions}
      options={options}
      localization={localization}
      isLoading={isLoading}
      components={components}
    />
  );
};

TeamAlertsGrid.propTypes = {
  keyGrid: PropTypes.number.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  actions: PropTypes.array,
  options: PropTypes.object.isRequired,
  localization: PropTypes.object,
  isLoading: PropTypes.bool,
  components: PropTypes.object
};

TeamAlertsGrid.defaultProps = {
  actions: [],
  localization: {},
  isLoading: false,
  components: {}
};

export default TeamAlertsGrid;
